import script from "./AreaEquipment.vue?vue&type=script&setup=true&lang=js"
export * from "./AreaEquipment.vue?vue&type=script&setup=true&lang=js"

import "./AreaEquipment.vue?vue&type=style&index=0&id=0f0eb5d6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f0eb5d6"]])

export default __exports__